import './style/index';
import _Swiper from './Swiper';

export type { SwiperProps } from './Swiper';
export * from './type';

export const Swiper = _Swiper;
export default Swiper;
